import baseApi, {
    provideTags,
    transformResponseFromData,
} from 'store/slices/api/baseApi'

const paymentsApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getPaymentUrl: build.mutation({
            query: () => ({url: 'Tranzila/getPaymentUrl', method: 'GET'}),
            transformResponse: transformResponseFromData,
            providesTags: (result) =>
                provideTags('Payment', result, 'PaymentUrl'),
        }),
    }),
    overrideExisting: false,
})

export default paymentsApi

export const {useGetPaymentUrlMutation} = paymentsApi
